import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import { toast } from "react-toastify";
import {
  getAllProductReferrals,
  getGst,
  productAdd,
  productList,
  productTypesList,
  subCategoryList,
  updateProductApi,
  updateProductStatus,
  updateProductToggle,
} from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Product = () => {
  const [subCategory, setSubCategory] = useState([]);
  const [bookingType, setBookingType] = useState([]);
  const [gstList, setGstList] = useState([]);
  const [product, setProduct] = useState([]);
  const [productUpdated, setProductUpdated] = useState(false);
  const [image, setImage] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedAllProduct, setSelectedAllProduct] = useState(null);
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentProd = product.slice(indexOfFirst, indexOfLast);

  const [showProductReferralsModal, setShowProductReferralsModal] =
    useState(false);
  const [productReferrals, setProductReferrals] = useState([]);
  const [referralsLoading, setReferralsLoading] = useState(false);

  const navigate = useNavigate();
  const handleViewDetails = (product) => {
    setSelectedAllProduct(product);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAllProduct(null);
  };

  const switchToAddTab = () => {
    document.querySelectorAll(".nav-link").forEach((tab) => {
      tab.classList.remove("active");
    });
    const addTab = document.querySelector('a[href="#Student-add"]');
    addTab.classList.add("active");
    document.querySelectorAll(".tab-pane").forEach((pane) => {
      pane.classList.remove("show", "active");
    });

    const addTabPane = document.getElementById("Student-add");
    addTabPane.classList.add("show", "active");
  };

  const [formData, setFormData] = useState({
    productName: "",
    bookingTypeId: "",
    productGst: "",
    productHsn: "",
    purchaseRate: "",
    purchasePrice: "",
    saleRate: "",
    salePrice: "",
    productSubCategoryId: "",
    warrantyPeriodInMonths: "",
    companyName: "",
    companyGroup: "",
    modelName: "",
    style: "",
    retailSalePrice: "",
    retailSaleRate: "",
    retailProductGstAmount: "",
  });

  useEffect(() => {
    const fetchSubcategoryList = async () => {
      try {
        const response = await subCategoryList(token);
        setSubCategory(response);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };
    const fetchProductTypeList = async () => {
      try {
        try {
          const response = await productTypesList(token);
          console.log("booking type", response);

          setBookingType(response);
        } catch (error) {
          console.error("Error fetching subcategories:", error);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchGstList = async () => {
      try {
        const response = await getGst(token);
        setGstList(response);
      } catch (error) {
        console.error("Error fetching GST list:", error);
      }
    };

    fetchProductTypeList();
    fetchSubcategoryList();
    fetchGstList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = { ...formData, [name]: value };

    if (name === "stock") {
      toast.info("To increase Stock,add new item to purchase list");
      return;
    }

    if (
      name === "productGst" ||
      name === "purchaseRate" ||
      name === "purchasePrice" ||
      name === "saleRate" ||
      name === "salePrice" ||
      name === "retailSaleRate" ||
      name === "retailSalePrice"
    ) {
      const gstValue = parseFloat(updatedFormData.productGst) || 0;
      const purchaseRate = parseFloat(updatedFormData.purchaseRate) || 0;
      const purchasePrice = parseFloat(updatedFormData.purchasePrice) || 0;
      const saleRate = parseFloat(updatedFormData.saleRate) || 0;
      const salePrice = parseFloat(updatedFormData.salePrice) || 0;
      const retailSaleRate = parseFloat(updatedFormData.retailSaleRate) || 0;
      const retailSalePrice = parseFloat(updatedFormData.retailSalePrice) || 0;

      if (name === "purchaseRate" && !isNaN(purchaseRate)) {
        updatedFormData.purchasePrice = (
          purchaseRate +
          (purchaseRate * gstValue) / 100
        ).toFixed(2);
      }
      if (name === "purchasePrice" && !isNaN(purchasePrice)) {
        updatedFormData.purchaseRate = (
          purchasePrice /
          (1 + gstValue / 100)
        ).toFixed(2);
      }
      if (name === "saleRate" && !isNaN(saleRate)) {
        updatedFormData.salePrice = (
          saleRate +
          (saleRate * gstValue) / 100
        ).toFixed(2);
      }
      if (name === "salePrice" && !isNaN(salePrice)) {
        updatedFormData.saleRate = (salePrice / (1 + gstValue / 100)).toFixed(
          2,
        );
      }
      if (name === "retailSalePrice" && !isNaN(purchasePrice)) {
        updatedFormData.retailSaleRate = (
          retailSalePrice /
          (1 + gstValue / 100)
        )
          // retailSalePrice -
          // (retailSalePrice * retailProductGstPercent) / 100
          .toFixed(2);

        updatedFormData.retailProductGstAmount = (
          retailSalePrice - updatedFormData.retailSaleRate
        ).toFixed(2);
      }
      if (name === "retailSaleRate" && !isNaN(purchaseRate)) {
        updatedFormData.retailSalePrice = (
          retailSaleRate +
          (retailSaleRate * gstValue) / 100
        )
          // retailSalePrice -
          // (retailSalePrice * retailProductGstPercent) / 100
          .toFixed(2);

        updatedFormData.retailProductGstAmount = (
          retailSalePrice - updatedFormData.retailSaleRate
        ).toFixed(2);
      }
    }

    setFormData(updatedFormData);
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });
    if (image) {
      data.append("productImageFile", image);
    }

    data.append("retailProductGstPercent", parseFloat(formData.productGst));
    data.append("stock", 0);

    data.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    if (editMode && selectedProduct) {
      data.append("id", selectedProduct.id);
    }

    try {
      let response;
      if (editMode) {
        response = await updateProductApi(data, token);
        console.log("Update Product : ", response);
      } else {
        response = await productAdd(data, token);
        console.log("Product add: ", response);
      }
      if (response.status === 200) {
        toast.success(
          editMode
            ? "Product updated successfully"
            : "Product added successfully",
        );
        navigate("/product");
        setProductUpdated((prev) => !prev);
        setEditMode(false);
        setSelectedProduct(null);
        setFormData({
          productName: "",
          bookingTypeId: "",
          productGst: "",
          productHsn: "",
          purchaseRate: "",
          purchasePrice: "",
          saleRate: "",
          salePrice: "",
          productSubCategoryId: "",
          companyName: "",
          companyGroup: "",
          modelName: "",
          style: "",
          warrantyPeriodInMonths: "",

          retailSalePrice: "",
          retailSaleRate: "",
          retailProductGstAmount: "",
        });
        setImage(null);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const toggleOnlineStatus = async (id) => {
    try {
      const response = await updateProductStatus(id, token);
      console.log("online status :", response);
      if (response.data.status === "success") {
        console.log("don");
        setProductUpdated((prev) => !prev);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const toggleStatus = async (id) => {
    try {
      const response = await updateProductToggle(id, token);
      console.log("toggle status :", response);
      if (response.data.status === "success") {
        setProductUpdated((prev) => !prev);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  useEffect(() => {
    const fetchProductList = async () => {
      try {
        const response = await productList(token);
        console.log("product list:", response);
        setProduct(response.products);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchProductList();
  }, [productUpdated]);

  const handleGetProductReferrals = async () => {
    setShowProductReferralsModal(true);
    setReferralsLoading(true);

    try {
      const response = await getAllProductReferrals(token);
      console.log("All Product Referrals:", response);
      setProductReferrals(response?.data || []);
    } catch (error) {
      console.error("Error fetching product referrals:", error);
      toast.error("Failed to fetch product referrals");
    } finally {
      setReferralsLoading(false);
    }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Products</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Products
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Student-all" // Matches id="Student-all"
                  >
                    List View
                  </a>
                </li>
                <li className="nav-item">
                  <button
                    className="doctor-primary-btn"
                    style={{ backgroundColor: "#0972c7" }}
                    data-toggle="tab"
                    onClick={handleGetProductReferrals}
                  >
                    All referrals
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="doctor-primary-btn"
                    data-toggle="tab"
                    href="#Student-add"
                  >
                    Add New
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-all">
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Id</th>
                        <th style={{ textAlign: "center" }}>Product Image</th>
                        <th style={{ textAlign: "center" }}>Product Name</th>

                        <th style={{ textAlign: "center" }}>Product Gst</th>
                        <th style={{ textAlign: "center" }}>Product Hsn</th>
                        <th style={{ textAlign: "center" }}>Stock</th>
                        <th style={{ textAlign: "center" }}>Purchase Rate</th>
                        <th style={{ textAlign: "center" }}>Purchase Price</th>
                        <th style={{ textAlign: "center" }}>Sale Rate</th>

                        <th style={{ textAlign: "center" }}>Sale Price</th>
                        <th style={{ textAlign: "center" }}>Online Status</th>
                        <th style={{ textAlign: "center" }}>Status</th>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentProd?.map((Product, indx) => (
                        <tr key={Product?.id}>
                          <td>{indexOfFirst + indx + 1}</td>
                          <td className="w60">
                            <img
                              className="avatar"
                              src="../assets/images/xs/avatar1.jpg"
                              alt=""
                            />
                          </td>
                          <td>
                            <span className="font-16">
                              {Product.productName}
                            </span>
                          </td>
                          <td>{Product?.productGst}</td>
                          <td>{Product?.productHsn}</td>
                          <td>{Product?.stock}</td>
                          <td>{Product?.purchaseRate}</td>
                          <td>{Product?.purchasePrice}</td>
                          <td>{Product?.saleRate}</td>

                          <td>{Product?.salePrice}</td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                Product?.onlineAvailable
                                  ? "btn-primary"
                                  : "btn-danger"
                              }`}
                              onClick={() => toggleOnlineStatus(Product?.id)}
                            >
                              {Product?.onlineAvailable ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                Product?.status ? "btn-primary" : "btn-danger"
                              }`}
                              onClick={() => toggleStatus(Product?.id)}
                            >
                              {Product?.status ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={() => handleViewDetails(Product)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="Edit"
                              onClick={() => {
                                switchToAddTab();
                                setEditMode(true);
                                setSelectedProduct(Product);
                                setFormData({
                                  productName: Product.productName,
                                  productGst: String(Product.productGst),
                                  productHsn: Product.productHsn,
                                  stock: Product.stock,
                                  purchaseRate: Product.purchaseRate,
                                  purchasePrice: Product.purchasePrice,
                                  saleRate: Product.saleRate,
                                  salePrice: Product.salePrice,
                                  saleMrp: Product.saleMrp,
                                  retailSalePrice: Product.retailSalePrice,
                                  retailSaleRate: (
                                    Product.retailSalePrice /
                                    (1 + Product.retailProductGstPercent / 100)
                                  ).toFixed(2),
                                  retailProductGstAmount:
                                    Product.retailSalePrice -
                                    Product.retailSaleRate,

                                  productSubCategoryId:
                                    Product.productSubCategoryId,
                                });
                              }}
                            >
                              <i className="fa fa-edit" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div
                    className="pagination mt-3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="btn btn-primary btn-sm me-2"
                    >
                      Prev
                    </button>

                    <span>
                      {" "}
                      Page {currentPage} of{" "}
                      {Math.ceil(product.length / itemsPerPage)}{" "}
                    </span>

                    <button
                      disabled={
                        currentPage === Math.ceil(product.length / itemsPerPage)
                      }
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="btn btn-primary btn-sm ms-2"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>

              <div className="tab-pane" id="Student-add">
                <div className="row clearfix">
                  <div className="col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">
                          {editMode ? "Edit" : "Add"} Basic Information
                        </h3>
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>
                        {Object.keys(formData).map((field) => (
                          <div className="form-group row" key={field}>
                            <label className="col-md-3 col-form-label">
                              {field
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9">
                              {field === "bookingTypeId" ? (
                                <select
                                  className="form-control"
                                  name={field}
                                  value={formData[field]}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select a Type</option>
                                  {bookingType.map((bookType) => (
                                    <option
                                      key={bookType.id}
                                      value={bookType.id}
                                    >
                                      {bookType.bookingType}
                                    </option>
                                  ))}
                                </select>
                              ) : field === "productSubCategoryId" ? (
                                <select
                                  className="form-control"
                                  name={field}
                                  value={formData[field]}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select a Subcategory</option>
                                  {subCategory.map((subcategory) => (
                                    <option
                                      key={subcategory.id}
                                      value={subcategory.id}
                                    >
                                      {subcategory.productSubCategoryName}
                                    </option>
                                  ))}
                                </select>
                              ) : field === "productGst" ? (
                                <select
                                  className="form-control"
                                  name={field}
                                  value={formData[field]}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select GST</option>
                                  {gstList.map((gst) => (
                                    <option
                                      key={gst.id}
                                      value={String(gst.gstPercent)}
                                    >
                                      {gst.gstPercent}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <input
                                  type={
                                    field.includes("Price") ||
                                    field.includes("Gst") ||
                                    field.includes("Rate")
                                      ? "number"
                                      : "text"
                                  }
                                  className="form-control"
                                  name={field}
                                  placeholder={`Enter ${field.replace(
                                    /([A-Z])/g,
                                    " $1",
                                  )}`}
                                  value={formData[field]}
                                  onChange={handleChange}
                                  required
                                />
                              )}
                            </div>
                          </div>
                        ))}
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Product Image
                          </label>
                          <div className="col-md-9">
                            <input
                              type="file"
                              className="form-control"
                              onChange={handleImageChange}
                            />
                          </div>
                        </div>

                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleCloseModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Product Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedAllProduct ? (
              <div>
                <p>
                  <strong>ID:</strong> {selectedAllProduct.id}
                </p>
                <p>
                  <strong>Product Name:</strong>{" "}
                  {selectedAllProduct.productName}
                </p>
                <p>
                  <strong>Subcategory ID:</strong>{" "}
                  {selectedAllProduct.productSubCategoryId}
                </p>
                <p>
                  <strong>GST:</strong> {selectedAllProduct.productGst}
                </p>
                <p>
                  <strong>HSN Code:</strong> {selectedAllProduct.productHsn}
                </p>
                <p>
                  <strong>Purchase Price:</strong> ₹
                  {selectedAllProduct.purchasePrice}
                </p>
                <p>
                  <strong>Purchase Rate:</strong> ₹
                  {selectedAllProduct.purchaseRate}
                </p>
                <p>
                  <strong>Sale MRP:</strong> ₹{selectedAllProduct.saleMrp}
                </p>
                <p>
                  <strong>Sale Price:</strong> ₹{selectedAllProduct.salePrice}
                </p>
                <p>
                  <strong>Sale Rate:</strong> ₹{selectedAllProduct.saleRate}
                </p>
                <p>
                  <strong>Stock:</strong> {selectedAllProduct.stock}
                </p>
                <p>
                  <strong>Online Available:</strong>{" "}
                  {selectedAllProduct.onlineAvailable ? "Active" : "Inactive"}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {selectedAllProduct.status ? "Active" : "Inactive"}
                </p>
              </div>
            ) : (
              <p>No details available</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {showProductReferralsModal && (
          <div
            onClick={() => setShowProductReferralsModal(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(20, 25, 35, 0.55)",
              backdropFilter: "blur(5px)",
              zIndex: 99999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: "100%",
                maxWidth: "950px",
                maxHeight: "85vh",
                background: "#fff",
                borderRadius: "16px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  padding: "20px 24px",
                  borderBottom: "1px solid #eee",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Product Referrals
                  </h4>
                  <small style={{ color: "#888" }}>
                    All product referral records
                  </small>
                </div>

                <button
                  onClick={() => setShowProductReferralsModal(false)}
                  style={{
                    width: "34px",
                    height: "34px",
                    border: "none",
                    borderRadius: "50%",
                    background: "#f1f1f1",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>

              {/* Body */}
              <div style={{ padding: "20px 24px", overflowY: "auto" }}>
                {referralsLoading ? (
                  <div style={{ textAlign: "center", padding: "40px" }}>
                    Loading product referrals...
                  </div>
                ) : productReferrals.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: "#888",
                    }}
                  >
                    No product referrals found.
                  </div>
                ) : (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(280px, 1fr))",
                      gap: "16px",
                    }}
                  >
                    {productReferrals.map((item, index) => (
                      <div
                        key={item.id || index}
                        style={{
                          border: "1px solid #e5eaf0",
                          borderRadius: "12px",
                          overflow: "hidden",
                          background: "#fff",
                        }}
                      >
                        <div
                          style={{
                            padding: "13px 16px",
                            background: "#f0f6ff",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <strong style={{ color: "#245a9c" }}>
                            Referral #{item.id}
                          </strong>

                          <span
                            style={{
                              fontSize: "11px",
                              padding: "4px 9px",
                              borderRadius: "20px",
                              background: item.isActive ? "#dcfce7" : "#fee2e2",
                              color: item.isActive ? "#15803d" : "#b91c1c",
                            }}
                          >
                            {item.isActive ? "Active" : "Inactive"}
                          </span>
                        </div>

                        <div style={{ padding: "16px" }}>
                          {[
                            ["Checkout ID", item.checkoutId],
                            ["Patient ID", item.patientId],
                            ["Patient Name", item.patientName],
                            ["Product ID", item.productId],
                            ["Service ID", item.serviceId],
                            ["Patient Service ID", item.patientServiceId],
                            ["Customize Request ID", item.customizeRequestId],
                            ["Store Sell ID", item.storeSellId],
                            ["Referred By Name", item.referredByName],
                            [
                              "Referred By Category ID",
                              item.referredByCategoryId,
                            ],
                            [
                              "Referred By User ID",
                              item.referredByCommonUserId,
                            ],
                            ["Referred Chamber ID", item.referredChamberId],
                            ["Commission Amount", item.commissionAmount],
                            ["Commission Rate", item.commissionRate],
                            [
                              "Referred At",
                              item.referredAt
                                ? new Date(item.referredAt).toLocaleString(
                                    "en-IN",
                                  )
                                : "-",
                            ],
                            ["Remarks", item.remarks],
                          ].map(([label, value]) => (
                            <div
                              key={label}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "12px",
                                padding: "8px 0",
                                borderBottom: "1px solid #f1f3f5",
                                fontSize: "13px",
                              }}
                            >
                              <span style={{ color: "#777" }}>{label}</span>
                              <strong
                                style={{
                                  color: "#333",
                                  textAlign: "right",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {value ?? "-"}
                              </strong>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default Product;
